<template>
  <section style="display: inherit">
    <a @click="fnShowModal()" v-b-tooltip.hover title="Lead Transfer"
      ><i class="las la-exchange-alt text-primary fs-1100"></i
    ></a>

    <b-modal ref="modal" hide-footer title="Lead Transfer">
      <div class="d-block">
        <dl class="row">
          <dt class="col-sm-4">Lead Id</dt>
          <dd class="col-sm-8">{{ id }}</dd>
          <dt class="col-sm-4">Lead Source</dt>
          <dd class="col-sm-8">{{ leadSource }}</dd>
          <dt class="col-sm-4">Dealer</dt>
          <dd class="col-sm-8">{{ dealer }}</dd>
          <dt class="col-sm-4">Business manager</dt>
          <dd class="col-sm-8">{{ dealer_manager }}</dd>
          <dt class="col-sm-4">Client name</dt>
          <dd class="col-sm-8">{{ client }}</dd>
          <dt class="col-sm-4">Current status</dt>
          <dd class="col-sm-8">
            <WDLeadsStatusBadge :status="status"></WDLeadsStatusBadge>
          </dd>
        </dl>

        <hr />

        <dl class="row">
          <dt class="col-sm-4">Select User</dt>
          <dd class="col-sm-8">
            <div class="form-group">
              <multiselect
                v-model="dealerUserObj"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a user"
                track-by="id"
                :options="getDealerStaffDropdown"
                label="name"
                :taggable="true"
                :allow-empty="false"
              >
              </multiselect>
            </div>
          </dd>
        </dl>

        <hr />
        <div class="text-right">
          <button
            type="button"
            class="btn btn-secondary btn-sm mr-2"
            @click="hideModal"
          >
            Cancel
          </button>
          <button
            type="button"
            @click="fnUpdate()"
            class="btn btn-success btn-sm"
          >
            Update
          </button>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../services/auth.service'
import * as messageService from '../../services/message.service'
import * as leadsService from '../../services/leads.service'
import datePicker from 'vue2-datepicker'
import WDLeadsStatusBadge from '../../components/wd/WDLeadsStatusBadge.vue'
export default {
  name: 'ModalLeadsTransfer',
  props: ['quoteId'],
  components: {
    datePicker,
    WDLeadsStatusBadge
  },
  data() {
    return {
      errors: {},
      loginUserObj: {},
      dealerId: '',
      dealerUserObj: { id: -1, name: '', email: '', mobile: '' },
      id: '',
      leadSource: '',
      status: '',
      dealer: '',
      dealer_manager: '',
      client: ''
    }
  },
  computed: {
    ...mapGetters([
      'getAdminLeadsPaginate',
      'getDealerStaffDropdown',
      'getLeadsPaginateData'
    ])
  },
  methods: {
    ...mapActions([
      'fetchAdminLeadsPaginate',
      'fetchDealerStaffDropdown',
      'fetchLeadsPaginate'
    ]),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.id = ''
      this.leadSource = ''
      this.dealerId = ''
      this.status = ''
      this.dealer = ''
      this.dealer_manager = ''
      this.client = ''
      this.dealerUserObj = { id: -1, name: '', email: '', mobile: '' }
      this.$refs.modal.hide()
    },
    async showModal() {
      this.loginUserObj = await authService.getUserFromToken()
      this.fetchDealerStaffDropdown(73)
      this.fnQuoteSingle(this.quoteId)
      this.$refs.modal.show()
    },

    fnUpdate: async function () {
      /**
       * Check if not RDL, needs leads goes to Vehicle solution with dealer id 73 and created user will take VSA assigned user
       * if RDL, Dealer and created user no change
       */
      if (this.leadSource != 'RDL') {
        this.dealerId = 73
      }

      const obj = {
        dealerId: this.dealerId,
        createdBy: this.dealerUserObj.id
      }

      try {
        this.errors = {}
        const response = await leadsService.transferDealer(this.id, obj)
        const { status_code } = response.data

        if (status_code == 200) {
          const { role_id } = this.loginUserObj
          if (role_id == 1 || role_id == 2) {
            this.fetchAdminLeadsPaginate(this.getAdminLeadsPaginate)
          }

          if (role_id == 3) {
            this.fetchLeadsPaginate(this.getLeadsPaginateData)
          }

          messageService.fnSweetAlertSuccessToast(
            'Leads status',
            'Transferred successfully '
          )

          this.hideModal()
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Leads transferred ',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Leads transferred ',
              'Something wrong'
            )
            break
        }
        console.log('fnUpdate - something wrong', error)
      }
    },
    fnQuoteSingle: async function (quoteId) {
      try {
        const response = await leadsService.single(quoteId)
        let data = response.data

        let firstName = ''
        let middleName = ''
        let lastName = ''

        this.id = data?.id
        this.leadSource = data?.leadSource
        this.status = data?.status
        this.dealerId = data?.dealerId
        this.dealer = data?.dealer?.name || ''
        this.dealer_manager = data?.client?.created_user?.firstName || ''

        firstName = data?.client?.firstName
        middleName = data?.client?.middleName
        lastName = data?.client?.lastName

        this.client = firstName + ' ' + middleName + ' ' + lastName
      } catch (error) {
        const obj = {
          type: 'error',
          title: error.response.data.error.name,
          text: error.response.data.error.message,
          footer: 'Error code: ' + error.response.data.error.statusCode
        }

        messageService.fnSweetAlertDisplay(obj)
      }
    }
  }
}
</script>
